import { render, staticRenderFns } from "./ValidatePopup.vue?vue&type=template&id=2262fde7&scoped=true&"
import script from "./ValidatePopup.vue?vue&type=script&lang=js&"
export * from "./ValidatePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2262fde7",
  null
  
)

export default component.exports